import { STATUSES } from "../../../../enums/AppointmentStatus";

export function parsePendingAppointment(appointment, status, statusMessage) {
  return {
    ...appointment,
    status: status,
    statusMessage: status == STATUSES.ACTIVE ? null : statusMessage,
  };
}
